import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FamilyDetailsContainerComponent } from './family-details-container.component';

const routes: Routes = [
	{
		path: '',
		component: FamilyDetailsContainerComponent,
		children: [
			{
				path: '',
				redirectTo: 'latest-holdings',
				pathMatch: 'full'
			},
			{
				path: 'latest-holdings',
				loadChildren: () => import('../family-latest-holdings/family-latest-holdings.module').then(mod => mod.FamilyLatestHoldingsModule)
			},
			{
				path: 'changes-holdings',
				loadChildren: () => import('../family-changes-to-holdings/family-changes-to-holdings.module').then(mod => mod.FamilyChangesToHoldingsModule)
			},
			{
				path: 'commentary',
				loadChildren: () => import('../family-commentary/family-commentary.module').then(mod => mod.FamilyCommentaryModule)
			},
			{
				path: 'performance-commentary',
				loadChildren: () => import('../family-performance-commentary/family-performance-commentary.module').then(mod => mod.FamilyPerformanceCommentaryModule)
			},
			{
				path: 'performance',
				loadChildren: () => import('../family-performance/family-performance.module').then(mod => mod.FamilyPerformanceModule)
			},
			{
				path: 'esg-metrics',
				loadChildren: () => import('../family-esg-metrics/family-esg-metrics.module').then(mod => mod.FamilyEsgMetricsModule)
			},
			{
				path: 'additional-resources',
				loadChildren: () => import('../family-additional-resources/family-additional-resources.module').then(mod => mod.FamilyAdditionalResourcesModule)
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class FamilyDetailsContainerRoutingModule { }
